import { supabase } from "../lib/supabase";
import type { Folder } from "../types/folder";

export async function findFoldersByUser(userId: string): Promise<Folder[]> {
  const { data, error } = await supabase
    .from("folders")
    .select("*")
    .eq("user_id", userId)
    .order("created_at", { ascending: true });

  if (error) throw error;
  return (data ?? []) as Folder[];
}

export async function createFolder(
  userId: string,
  name: string,
  color: string,
): Promise<Folder> {
  const { data, error } = await supabase
    .from("folders")
    .insert({ user_id: userId, name, color })
    .select()
    .single();

  if (error || !data) throw error ?? new Error("폴더 생성 실패");
  return data as Folder;
}

export async function deleteFolder(folderId: string): Promise<void> {
  const { error } = await supabase.from("folders").delete().eq("id", folderId);

  if (error) throw error;
}
